<template>
  <div>
    <LowerB
      class="banner-design-elements"
      width="200"
      style="right: 50px; top:-20px; opacity: 0.5"
    />
    <Leaf
      class="banner-design-elements"
      width="100"
      style="right: 200px; top:10px; opacity: 0.4"
      stroke
      :stroke-width="1"
    />
  </div>
</template>

<script>
import Leaf from '@/components/design-elements/leaf.vue'
import LowerB from '@/components/design-elements/lowerB.vue'

export default {
  components: {
    Leaf,
    LowerB
  }
}
</script>
